module.exports = __webpack_public_path__ + "static/media/illustration-woman-online-mobile.daf66934.svg";